import React from "react";
import { ErrorMessage, useFormikContext } from "formik";
import FormControl from "@mui/material/FormControl";
import { styled } from "@mui/material/styles";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import { titleCase } from "../../CommonFuntion/SchemaValidation";
import { applyMaskOnBlur } from "../../CommonFuntion/applyMaskOnBlur";
const CssTextField = styled(TextField)({
  ".MuiFormLabel-root": {},
  "& label.Mui-focused": {
    color: "#ec0000c4",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#ec0000c4",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#ec0000c4",
    },
    "&:hover fieldset": {
      borderColor: "#ec0000c4",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#ec0000c4",
    },
  },
});

export function TextBox(props) {
  const { name, value, label, tagName, validation, prefix } = props;

  const { setFieldValue, values } = useFormikContext();
  const id = `${tagName}-input`;

  const handleChange = (e) => {
    const { value } = e.target;
    setFieldValue([name], value);
  };

  const handleBlur = (e) => {
    if (!validation?.pictureMask) return;
    const { nextValue, applied } = applyMaskOnBlur(
      e.target.value,
      validation.pictureMask
    );
    if (applied) {
      setFieldValue([name], nextValue);
    }
  };

  return (
    <>
      <div className="flex-container">
        <div className="control-bottom-border">
          {label && (
            <label className="font-css" htmlFor={id}>
              {titleCase(label.replace("_", " "))}
              {validation?.mandatory && (
                <span className="mandatory-validation">{"*"}</span>
              )}
            </label>
          )}
        </div>

        <div className="control-bottom-border" autoComplete="off">
          <FormControl variant="standard">
            <Tooltip
              title={
                validation.pictureMask
                  ? "Picture Mask:" + validation.pictureMask
                  : ""
              }
            >
              <CssTextField
                id={id}
                type="text"
                name={name}
                key={name}
                tagname={tagName}
                fieldname={name}
                prefix={prefix}
                fullWidth
                placeholder=""
                style={{
                  fontSize: "12px",
                  width: "200px",
                }}
                onChange={handleChange}
                onBlur={handleBlur}
                onKeyPress={(e) => !/[0-9]/.test(e.key) && e.preventDefault()}
                variant="standard"
                value={values?.[name] || ""}
              ></CssTextField>
            </Tooltip>
          </FormControl>
          <ErrorMessage
            name={name}
            render={(msg) => {
              return <div className="is-invalid">{msg}</div>;
            }}
          />
        </div>
      </div>
    </>
  );
}
